export const OauthPopup = () => {
  const popup = document.querySelector('.js-oauth-popup');
  const confirmButton = popup?.querySelector('.js-oauth-popup-confirm');
  const cancelButton = popup?.querySelector('.js-oauth-popup-cancel');
  const consentCheckbox = popup?.querySelector('.js-oauth-popup-consent');
  let confirmHref = null;
  let confirmMethod = 'get';

  if (!popup || !confirmButton) return;

  const setConfirmDisabled = (disabled) => {
    confirmButton.classList.toggle('pointer-events-none', disabled);
    confirmButton.classList.toggle('opacity-50', disabled);
    confirmButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');

    if (disabled) {
      confirmButton.setAttribute('tabindex', '-1');
    } else {
      confirmButton.removeAttribute('tabindex');
    }
  };

  const closePopup = () => {
    popup.classList.add('hidden');

    if (consentCheckbox) {
      consentCheckbox.checked = false;
    }

    setConfirmDisabled(true);
  };

  const submitOAuthRequest = () => {
    if (!confirmHref) return;

    if (confirmMethod.toLowerCase() === 'post') {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = confirmHref;
      form.style.display = 'none';

      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
      const csrfParam = document.querySelector('meta[name="csrf-param"]')?.getAttribute('content') || 'authenticity_token';

      if (csrfToken) {
        const tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = csrfParam;
        tokenInput.value = csrfToken;
        form.appendChild(tokenInput);
      }

      document.body.appendChild(form);
      form.submit();
      return;
    }

    window.location.assign(confirmHref);
  };

  document.querySelectorAll('.js-oauth-popup-trigger').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const href = trigger.getAttribute('href');
      const method = trigger.getAttribute('data-oauth-method') || 'get';

      confirmHref = href;
      confirmMethod = method;

      if (consentCheckbox) {
        consentCheckbox.checked = false;
      }

      setConfirmDisabled(true);
      popup.classList.remove('hidden');
    });
  });

  confirmButton.addEventListener('click', (event) => {
    event.preventDefault();

    if (confirmButton.getAttribute('aria-disabled') === 'true') {
      return;
    }

    closePopup();
    submitOAuthRequest();
  });

  if (cancelButton) {
    cancelButton.addEventListener('click', (event) => {
      event.preventDefault();
      closePopup();
    });
  }

  if (consentCheckbox) {
    consentCheckbox.addEventListener('change', () => {
      setConfirmDisabled(!consentCheckbox.checked);
    });
  }

  setConfirmDisabled(true);
};
